module.exports = __webpack_public_path__ + "static/media/Why_us_image.77c44862.jpg";